import gql from 'graphql-tag';
import { graphql } from '@apollo/react-hoc';
import compose from 'recompose/compose';
import branch from 'recompose/branch';
import renderNothing from 'recompose/renderNothing';
import renderComponent from 'recompose/renderComponent';
import withProps from 'recompose/withProps';
import setDisplayName from 'recompose/setDisplayName';
import { authorized } from '../containers/Authorization';
import GraphQLLoader from '../components/GraphQLLoader';
import GraphQLError from '../components/GraphQLError';

const EnabledFeaturesQuery = gql`
  query enabledFeatures {
    viewer {
      id
      enabledFeatures
    }
  }
`;

const withEnabledFeatures = compose(
  authorized(),
  setDisplayName('withEnabledFeatures'),
  graphql(EnabledFeaturesQuery),
  GraphQLLoader,
  GraphQLError,
  withProps(({ data: { viewer } }) => ({
    enabledFeatures: viewer && viewer.enabledFeatures,
  })),
);

function hasFeature(features, options, enabled) {
  return compose(
    setDisplayName(enabled ? 'onFeatureEnabled': 'onFeatureDisabled'),
    withEnabledFeatures,
    branch(
      ({ enabledFeatures }) => [].concat(features).every((feature) => enabledFeatures.includes(feature) !== enabled),
      renderComponent(options.failure || renderNothing()),
    ),
  );
}

const onFeatureEnabled = (features, options) => hasFeature(features, options || {}, true);
const onFeatureDisabled = (features, options) => hasFeature(features, options || {}, false);

export { EnabledFeaturesQuery, withEnabledFeatures, onFeatureEnabled, onFeatureDisabled };
